import React, {useEffect, useState} from "react";
import CardNuoto from "../../components/nuoto/CardNuoto";
import nuotoLibero from "../../images/home/copertine2025/NuotoLibero.png"
import corsi from "../../images/home/copertine2025/CorsiNuoto.png"
import individuali from "../../images/home/copertine2025/Individuali.png"
import acquaGym from "../../images/home/copertine2025/Acquafitness.png"
import riabilitazione from "../../images/Nuoto/Riabilitazione/foto5.jpg"
import master from "../../images/Nuoto/Master/DSCF9116.jpg"
import "../../styles/CardNuoto.css"
import CaroselloStandard from "../../commons/CaroselloStandard";
import foto1 from "../../images/Nuoto/IMG_8637.jpg"
import {url} from "inspector";
import Titolo from "../../commons/Titolo";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Space from "../../commons/Space";
import CardMultitessere from "../../components/CardMultitessere";
import TitoloSezioni from "../../commons/TitoloSezioni";
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';
import foto360 from "../../images/home/foto360_noCav00086401.jpg"
import "../../styles/360viewer.css"
import DanzaPacchettixxl from "../../components/danza/DanzaPachettixxl";
import DanzaPacchettiMedia from "../../components/danza/DanzaPacchettiMedia";
import SpaceL from "../../commons/SpaceL";
import {NavLink} from "react-router-dom";
import CardNewsEvidenza from "../../components/CardNewsEvidenza";
import CardInEvidenza from "../../components/CardInEvidenza";
import estivi from "../../images/Estivi/Estivi_card.jpg";
import barista from "../../images/News/Barista.jpg";
import preBambini from "../../images/PreIscrizioni/25.png";
import preAdulti from "../../images/PreIscrizioni/24.png";
import novità from "../../images/PreIscrizioni/A3.png";
import NewCard from "../../components/home/NewCard";
import NewCardNuoto from "../../components/nuoto/NewCardNuoto";
import {Helmet} from "react-helmet";


function Nuoto() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    return(
        <div>
            <Helmet>
                <title>Piscina</title>
                <meta name="description" content="Scopri tutti i nostri corsi di nuoto e acquafitness" />
            </Helmet>
            <ScrollToTopOnMount />
            <Titolo title={"Piscina"} backgroundImage={foto1} />
            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>
            {/*
            <div className="m-auto" style={{maxWidth: "90%"}}>
                <p style={{fontSize: "32px", fontFamily: "Hammersmith One"}}>In evidenza</p>
                <hr/>
                <div className="d-none d-sm-block" >
                    <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <CardInEvidenza foto={estivi} titolo={"Corsi estivi 2024"} descrizione={""} data={"10.05.2024"} indirizzo={"../corsiestivi"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                        <CardInEvidenza foto={preBambini} titolo={"Pre-iscrizioni nuoto bambini"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/preiscrizionibambini"} settore1={"piscina"} posizioneFoto={"top"}/>
                        <CardInEvidenza foto={preAdulti} titolo={"Pre-iscrizioni nuoto adulti"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/preiscrizioniadulti"} settore1={"piscina"} posizioneFoto={"top"}/>
                        <CardInEvidenza foto={novità} titolo={"Novità 2024"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/novità2024"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                         </div>
                </div>
                <div className="d-sm-none  " >
                    <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>
                        <CardNewsEvidenza foto={estivi} titolo={"Corsi estivi 2024"} descrizione={""} data={"10.05.2024"} indirizzo={"../corsiestivi"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                        <CardNewsEvidenza foto={preBambini} titolo={"Pre-iscrizioni nuoto bambini"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/preiscrizionibambini"} settore1={"piscina"} posizioneFoto={"top"}/>
                        <CardNewsEvidenza foto={preAdulti} titolo={"Pre-iscrizioni nuoto adulti"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/preiscrizioniadulti"} settore1={"piscina"} posizioneFoto={"top"}/>
                        <CardNewsEvidenza foto={novità} titolo={"Novità 2024"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/novità2024"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                        </div>
                </div>

            </div>
            */}
            <SpaceL />
            <TitoloSezioni title={"I nostri corsi"} />
            <div className="card-container d-flex flex-row  justify-content-center flex-wrap">
                <div className="d-flex flex-row flex-wrap justify-content-center">
                    <NewCardNuoto image={corsi} title={"Corsi di nuoto"} indirizzo={"/corsinuoto"} coloreSettore="#74B9C7"/>
                    <NewCardNuoto image={nuotoLibero} title={"Nuoto libero"} indirizzo={"/nuotolibero"} coloreSettore="#74B9C7"/>
                </div>
                <div className="d-flex flex-row flex-wrap justify-content-center">
                    <NewCardNuoto image={individuali} title={"Lezioni individuali"} indirizzo={"/lezionindividuali"} coloreSettore="#74B9C7" />
                    <NewCardNuoto image={acquaGym} title={"Acquafitness"} indirizzo={"/acquafitness"} coloreSettore="#74B9C7"/>
                    {/*
                    <NewCardNuoto image={riabilitazione} title={"Riabilitazione motoria"} indirizzo={"/riabilitazionemotoria"}/>
                    <NewCardNuoto image={master} title={"Master"} indirizzo={"/master"} />
                    */}
                </div>
            </div>


            <Space/>

            {windowWidth > 900 ? (
                <div>
                    <figure className="text-center">
                        <blockquote className="blockquote">
                            <p style={{fontSize: "30px", padding:"1em", fontFamily: "Hammersmith One"}}> Scorri sull'immagine per visualizzare la piscina a 360°</p>
                        </blockquote>
                    </figure>
                <div className="m-auto" style={{width: "80%"}}>
                    <ReactPhotoSphereViewer src={foto360} height={'80vh'} width={"100%"} defaultYaw={"160"} mousewheel={false} mousewheelCtrlKey={true}></ReactPhotoSphereViewer>
                </div>
                </div>
            ):
                windowWidth > 650 && windowWidth < 900 ? (
                    <div>
                        <figure className="text-center">
                            <blockquote className="blockquote">
                                <p style={{fontSize: "25px", padding:"1em", fontFamily: "Hammersmith One"}}> Scorri sull'immagine per visualizzare la piscina a 360°</p>
                            </blockquote>
                        </figure>
                <div className="m-auto" style={{width: "90%"}}>
                    <ReactPhotoSphereViewer  src={foto360} height={'60vh'} width={"100%"} defaultYaw={"160"}></ReactPhotoSphereViewer>
                </div>
                    </div>
            )
            : (
                <div>
                    <figure className="text-center">
                        <blockquote className="blockquote">
                            <p style={{fontSize: "22px", padding:"1em", fontFamily: "Hammersmith One"}}> Scorri sull'immagine per visualizzare la piscina a 360°</p>
                        </blockquote>
                    </figure>
                <div className="m-auto" style={{width: "90%"}}>
                            <ReactPhotoSphereViewer src={foto360} height={'30vh'} width={"100%"} defaultYaw={"160"}></ReactPhotoSphereViewer>
                        </div>
                </div>
                    )}

            <Space />
            <div className="d-flex flex-column text-center align-items-center justify-content-center">
                <TitoloSezioni title={"Multitessere"} />
                <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                <CardMultitessere />
            </div>
            <Space />
            <figure className="text-center">
                <blockquote className="blockquote">
                    <NavLink to={"/regolamentopiscina"} style={{fontSize: "22px", padding:"1em", fontFamily: "Hammersmith One", color: "#032041FF"}}>Regolamento piscina</NavLink>
                </blockquote>
            </figure>
            <Space />

        </div>
    )
}

export default Nuoto